import type { ComponentChildren } from 'preact'

import {
  dialogHeaderPaddingStyle,
  modalHeaderStyle,
  titleStyle,
  titleWithMarginStyle,
} from '../styles'

import { XIcon } from '#src/assets/ui/icons/XIcon.tsx'
import { Button } from '#src/assets/ui/shared/components/Button.tsx'

export function DialogHeader({
  title,
  className,
  titleClassName,
  children,
}: {
  title: string
  className?: string
  titleClassName?: string
  children?: ComponentChildren
}) {
  return (
    <div className={className} style={dialogHeaderPaddingStyle}>
      <div className={titleClassName} style={titleWithMarginStyle}>
        {title}
      </div>
      {children}
    </div>
  )
}

export function ModalHeaderWithClose({
  title,
  titleId,
  closeLabel,
  onClose,
}: {
  title: string
  titleId: string
  closeLabel: string
  onClose: () => void
}) {
  return (
    <div style={modalHeaderStyle}>
      <h2 id={titleId} style={titleStyle}>
        {title}
      </h2>
      <Button
        type="button"
        variant="closeIcon"
        aria-label={closeLabel}
        onClick={() => onClose()}
      >
        <XIcon />
      </Button>
    </div>
  )
}
